import ReviewAndApprove from '../../review-and-approve/ReviewAndApprove';

const EditProtocolIntelligence = () => {
  return <ReviewAndApprove />;
};

export default EditProtocolIntelligence;
